import React, { useState, useEffect } from 'react';
import * as ScenarioAPI from '../../services/ScenarioServices';
import { useNavigate } from 'react-router-dom';
import styles from './styles/AdminGlobalScenarios.module.css';
import SearchBar from '../common/SearchBar';

const AdminGlobalScenarios = () => {
    const navigate = useNavigate();
    const [allScenarios, setAllScenarios] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAllScenarios = async () => {
            try {
                setLoading(true);
                const data = await ScenarioAPI.getAllScenarios();
                setAllScenarios(data);
            } catch (err) {
                console.error("Failed to fetch admin data", err);
                if (err.response?.status === 403) {
                    navigate('/');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchAllScenarios();
    }, [navigate]);

    const handleScenarioNavigate = (scenarioId) => {
        navigate(`/admin-view/${scenarioId}`);
    };

    if (loading) return <div>Loading Admin Dashboard...</div>;

    return (
        <div className={styles.container}>
            <h1 className={styles.heading}>All Scenarios (Admin)</h1>
            <div>
                <SearchBar type={'scenarios'} setter={setSelectedItem} />
            </div>
            <div className={styles.cardContainer}>
                {allScenarios.map(scenario => (
                    (!selectedItem || 
                     (selectedItem.searchType === 'scenario' && selectedItem._id === scenario._id) || 
                     (selectedItem.searchType === 'user' && selectedItem._id === scenario?.creator?._id)) && (
                    <div key={scenario._id} className={styles.card}>
                        <button
                            className={styles.cardButton}
                            onClick={() => handleScenarioNavigate(scenario._id)}
                        >
                            <p className={styles.title}>{scenario.title}</p>
                            <p className={styles.creator}>Created by: {scenario?.creator?.username || "Unknown"}</p>
                            <p className={styles.id}>ID: {scenario._id}</p>
                        </button>
                    </div>
                    )
                ))}
            </div>
        </div>
    );
};

export default AdminGlobalScenarios;